module.exports = __webpack_public_path__ + "static/usage_check_data1-9d4710825b3e84f18d19696960ba513f.jpg";